import { getInsights } from "@antv/ava";
import { InsightCard } from "@antv/ava-react";
import { SearchResultType } from "../../list";
import React from "react";

export const AutoInsight: React.FC<{
  loadResult?: SearchResultType;
}> = ({ loadResult }) => {
  const insightResult = getInsights(loadResult?.data ?? [], {});
  return (
    <>
      {insightResult.insights.map((_insight) => (
        <InsightCard insightInfo={_insight} />
      ))}
    </>
  );
};
